import { Select } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useAppDomain } from "../../../hooks/appdomain/useAppDomain";
import { EmailHistoryProductCode } from "../../../helper/emailhistoryHelper";
import styled from "styled-components";


type ProductCodeFilterProps = {
  onChange: (value: EmailHistoryProductCode[]) => void;
  value?: EmailHistoryProductCode[];
};

export const EmailHistoryProductCodeFilter: React.FC<ProductCodeFilterProps> = ({
  value,
  onChange,
}) => {
  const SelectBoxWrapper = styled.div`
  max-width: 300px;
  min-width: 225px;
`;
  const { t } = useTranslation();
const {allEmailHistoryProductCodes} = useAppDomain();

  const productCodeOptions = (allEmailHistoryProductCodes).split(",").map(
    (productCodeName) => ({
      value: productCodeName,
      label:  t(`emailhistory.filter.productcode.options.${productCodeName}` as any),
    })
  );
  return (
    <SelectBoxWrapper>
    <Select
      mode="multiple"
      allowClear
      placeholder={t("emailhistory.filter.productcode.placeholder")}
      style={{ width: "100%", minWidth: "150px" }}
      maxTagCount={1}
      options={productCodeOptions}
      onChange={onChange}
      value={value}
    />
    </SelectBoxWrapper>
  );
};
